import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Card, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import Header from '../../../pages/Shared/Header/Header';
import Footer from '../../../pages/Shared/Footer/Footer';
import blog0 from '../../../img/blog0.png';
import blog1 from '../../../img/blog1.jpeg';
import blog2 from '../../../img/blog2.jpeg';
import blog3 from '../../../img/blog3.jpeg';
import blog4 from '../../../img/blog4.jpeg';
import blog5 from '../../../img/blog5.jpeg';
import { useApp } from '../../../contexts/AppContext';

const Blogs = () => {
   const { isInitialLoad, setIsInitialLoad } = useApp();

   useEffect(() => {
     if (isInitialLoad) return;
     setIsInitialLoad(true);
   }, [isInitialLoad, setIsInitialLoad]);
  
  const blogs = [
    {
      id: 0,
      blogName: 'A look at filter() vs. find() array methods in JavaScript',
      blogImg: blog0,
      shortDescription:
        'JavaScript provides two powerful and super useful array methods named filter() and find() methods. First, let’s get to know a little about both of these array methods before diving deep into the actual code. Suppose, we want to have a...',
      blogUrl:
        'https://medium.com/@ahmedtanvir6168/a-look-at-filter-vs-find-array-methods-in-javascript-d913dcafe8d1',
    },
    {
      id: 1,
      blogName: 'A Basic Introduction to Express JS',
      blogImg: blog1,
      shortDescription:
        'Express JS is known as a powerful Node JS web app framework that gives us diverse features that we need for building websites, web...',
      blogUrl:
        'https://medium.com/@ahmedtanvir6168/a-basic-introduction-to-express-js-cdfed0c5aaa',
    },
    {
      id: 2,
      blogName: 'Understanding JSX in ReactJS',
      blogImg: blog2,
      shortDescription:
        'JSX means JavaScript XML. We use JSX to write HTML in our React application. JSX enables us to write HTML like syntax in React applications...',
      blogUrl:
        'https://medium.com/@ahmedtanvir6168/understanding-jsx-in-reactjs-fb417cd7ac19',
    },
    {
      id: 3,
      blogName:
        'Understanding scope, block scope, window, global variable, global scope',
      blogImg: blog3,
      shortDescription:
        'Scope means the visibility and existence of a variable. The variable that is declared in scope is not visible outside that scope...',
      blogUrl:
        'https://medium.com/@ahmedtanvir6168/understanding-scope-block-scope-window-global-variable-global-scope-42257257f177',
    },
    {
      id: 4,
      blogName: 'A look at slice() vs. splice() array methods in JavaScript',
      blogImg: blog4,
      shortDescription:
        'Arrays in JavaScript are variables that are used to hold more than one value. And array values can be string, number, boolean, or anything...',
      blogUrl:
        'https://medium.com/@ahmedtanvir6168/a-look-at-slice-vs-splice-array-methods-in-javascript-d96d67b5f1ff',
    },
    {
      id: 5,
      blogName: 'A Basic Introduction to CSS Pseudo-Classes',
      blogImg: blog5,
      shortDescription:
        'Welcome to the basic introduction to CSS pseudo-classes. Pseudo-classes are a powerful feature available in CSS. We can use pseudo-classes...',
      blogUrl:
        'https://medium.com/@ahmedtanvir6168/a-basic-introduction-to-css-pseudo-classes-62d0d1bf1759',
    },
  ];

  const handleBlogClick = () => {
    window.open(blogs[0]?.blogUrl);
  };

  return (
    <>
      <Header></Header>
      <Container fluid className='pb-5'>
        <motion.h1
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className='text-center fw-bold mb-4  mt-5'
        >
          Read My Blogs
        </motion.h1>
        <motion.h4
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className='text-center mb-5 text-secondary pb-5 '
        >
          See all of latest blogs from here
        </motion.h4>
        <Row xs={1} md={2} className='g-1'>
          {blogs?.map((blog) => (
            <motion.div
              key={blog?.id}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 2 }}
            >
              <Col className='h-100'>
                <Card className='text-center h-100'>
                  <Card.Img
                    variant='top'
                    src={blog?.blogImg}
                    style={{ height: '300px' }}
                  />
                  <Card.Body className='d-flex flex-column justify-content-between'>
                    <div className='mb-4'>
                      <Card.Title className='fw-bolder text-start'>
                        {blog?.blogName}
                      </Card.Title>
                      <Card.Text
                        className='text-start'
                        style={{ marginBottom: '0px' }}
                      >
                        {blog?.shortDescription}
                      </Card.Text>
                    </div>

                    <div>
                      <Button
                        variant='primary fw-bold'
                        className=''
                        size='lg'
                        onClick={handleBlogClick}
                      >
                        Read More
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </motion.div>
          ))}
        </Row>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default Blogs;
